import * as qs from 'qs';
import {API} from '../API';
import {NoteService} from './NoteService';

export class InboxService {

  constructor() {
    this.note = new NoteService();
  }

  async getTableMessages(params, additional = {}) {
    const [query, page, length] = API.getTableParams(params, additional);
    return this.getMessages(query, page, length);
  }

  async getMessages(query, page, length) {
    return (await API.getConnection())
      .get('inbox', {
        params: {...query, ...{page, length}},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data)
      .catch(error => API.handleError(error));
  }

  async getMessage(id, archive = false) {
    return (await API.getConnection())
      .get(`inbox/${id}`, {
        params: archive ? {filter: {archive: 'only'}} : {},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async toggleMessage(message) {
    return (await API.getConnection())
      .post(`inbox/${message.id}`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async deleteMessage(message) {
    return (await API.getConnection())
      .delete(`inbox/${message.id}`)
      .then(() => null)
      .catch(error => API.handleError(error));
  }
}
